module.exports = __webpack_public_path__ + "static/img/13.0af70f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/travelpolicy/13.jpg
// module id = r4g8
// module chunks = 0